import formatDate from './formatDate';
import truncate from './truncate';

export default {
  formatDate,
  truncate,
};
